import './Setup';
import './Components';

import { default as context } from '@truckdown/systems';
import { IAppUserContext } from './IAppUserContext';

export type { IAppUserContext };
export type { IIconLoader } from './IIconLoader';
export type { IGenericSideNavItem } from './IGenericSideNavItem';
export type { NotificationReceivedHandler } from './Setup/NotificationReceivedHandler';

export { default as AsyncComponentLoading } from "./Components/Loading/Loading.vue";
export { default as AsyncComponentError } from "./Components/Error/Error.vue";

export { Constants as SystemConstants } from './constants';
export default context as IAppUserContext;